/**
 * This allows you to use any and not have eslint warning.
 * This is a bad practice, it should be used only when you really can't use unknown or never and you don't have any other choice.
 * When using anyReallyAny you must write a message to explain why.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type anyReallyAny = any;

/** Define an object strictly not null */
export type NonNull<T> = Extract<T, null>;

/** Defined an object strictly not undefined */
export type NonUndefined<T> = Extract<T, undefined>;

/** Defined undefined or null type */
export type NullOrUndefined = null | undefined;

/**
 * Will always return true
 * When using isAnyObject you must write a message to explain why.
 */
export function isAnyObject(obj: NonNullable<unknown>): obj is anyObject { return true; }

/**
 * Will always return true
 * When using isNonNullObject you must write a message to explain why.
 */
export function isNonNullObject<T>(obj: NonNull<T>): obj is NonNull<T> { return true; }

/**
 * Will always return true is
 * When using isNonUndefinedObject you must write a message to explain why.
 */
export function isNonUndefinedObject<T>(obj: NonUndefined<T>): obj is NonUndefined<T> { return true; }

/**
 * This allows you to use unknown typed object and not have typescript warning.
 * This is a bad practice, it should be used only when you really can't use unknown or never and you don't have any other choice.
 * When using anyObject you must write a message to explain why.
 */
export type anyObject = Record<string, anyReallyAny>;

/**
 * This will cast an object into an anyObject
 * When using isAnyObject you must write a message to explain why.
 */
export function asAnyObject<T>(obj: NonNullable<T>): anyObject { return obj as anyObject; }

/** Set an object property without type checking */
export function setProp<
    PropertyType,
    ObjectType extends anyObject = anyObject
>(obj: NonNullable<ObjectType>, field: string | number, value: PropertyType): void {
    asAnyObject(obj)[field] = value;
}

/** Get an object property without type checking */
export function getProp<
    PropertyType,
    ObjectType extends anyObject = anyObject
>(obj: NonNullable<ObjectType>, field: string | number): PropertyType {
    return asAnyObject(obj)[field];
}